import { takeEvery, put, all, fork, call } from 'redux-saga/effects'
import { GET_ALL_DICT_DETAILS } from '../../api/boot'
import {
  isResponseCodeSuccess,
  SetLocalStorage,
  GetLocalStorage,
} from '../../tools/util'
import { setDictDataAction, setDictLoadingAction, ActionType } from './index'

// 字典数据存储 key
const DICT_STORAGE_KEY = 'DICT_DATA' as const

/**
 * 处理字典数据，转换为以 dictCode 为 key 的对象
 * 接口返回格式: [{ dictCode: "SYSTEM.CATEGORY", dictName: "品类", detailList: [{ key: "0", value: "默认品类" }, ...] }]
 */
function formatDictData(data: any[]): { [dictCode: string]: any[] } {
  const dictMap: { [dictCode: string]: any[] } = {}

  if (Array.isArray(data)) {
    data.forEach((item) => {
      const dictCode = item.dictCode
      const detailList = item.detailList || []

      if (dictCode && Array.isArray(detailList)) {
        // 将 detailList 中的项转换为字典项列表
        dictMap[dictCode] = detailList.map((detail: any) => ({
          key: detail.key,
          value: detail.value,
          ...detail, // 保留其他字段
        }))
      }
    })
  }

  return dictMap
}

// 获取字典数据
function* getDictData(): any {
  try {
    yield put(setDictLoadingAction(true))

    // 先尝试从本地存储读取，快速初始化
    const localData = yield call(() => GetLocalStorage(DICT_STORAGE_KEY))
    if (localData && Object.keys(localData).length > 0) {
      yield put(setDictDataAction(localData))
    }

    // 调用接口获取最新数据
    const res = yield GET_ALL_DICT_DETAILS()

    if (isResponseCodeSuccess(res.code)) {
      const formattedData = formatDictData(res.data || [])

      // 存储到 Redux
      yield put(setDictDataAction(formattedData))

      // 存储到 localStorage
      SetLocalStorage(DICT_STORAGE_KEY, formattedData)
    }
  } catch (error) {
    console.error('Failed to fetch dict data:', error)
  } finally {
    yield put(setDictLoadingAction(false))
  }
}

function* alltask() {
  yield takeEvery<ActionType>('getDictData', getDictData)
}

// 导出当前模块的saga处理方法
export default function* sagas() {
  yield all([fork(alltask)])
}
import { takeEvery, put, all, fork, call } from 'redux-saga/effects'
import { GET_ALL_DICT_DETAILS } from '../../api/boot'
import {
  isResponseCodeSuccess,
  SetLocalStorage,
  GetLocalStorage,
} from '../../tools/util'
import { setDictDataAction, setDictLoadingAction, ActionType } from './index'

// 字典数据存储 key
const DICT_STORAGE_KEY = 'DICT_DATA' as const

/**
 * 处理字典数据，转换为以 dictCode 为 key 的对象
 * 接口返回格式: [{ dictCode: "SYSTEM.CATEGORY", dictName: "品类", detailList: [{ key: "0", value: "默认品类" }, ...] }]
 */
function formatDictData(data: any[]): { [dictCode: string]: any[] } {
  const dictMap: { [dictCode: string]: any[] } = {}

  if (Array.isArray(data)) {
    data.forEach((item) => {
      const dictCode = item.dictCode
      const detailList = item.detailList || []

      if (dictCode && Array.isArray(detailList)) {
        // 将 detailList 中的项转换为字典项列表
        dictMap[dictCode] = detailList.map((detail: any) => ({
          key: detail.key,
          value: detail.value,
          ...detail, // 保留其他字段
        }))
      }
    })
  }

  return dictMap
}

// 获取字典数据
function* getDictData(): any {
  try {
    yield put(setDictLoadingAction(true))

    // 先尝试从本地存储读取，快速初始化
    const localData = yield call(() => GetLocalStorage(DICT_STORAGE_KEY))
    if (localData && Object.keys(localData).length > 0) {
      yield put(setDictDataAction(localData))
    }

    // 调用接口获取最新数据
    const res = yield GET_ALL_DICT_DETAILS()

    if (isResponseCodeSuccess(res.code)) {
      const formattedData = formatDictData(res.data || [])

      // 存储到 Redux
      yield put(setDictDataAction(formattedData))

      // 存储到 localStorage
      SetLocalStorage(DICT_STORAGE_KEY, formattedData)
    }
  } catch (error) {
    console.error('Failed to fetch dict data:', error)
  } finally {
    yield put(setDictLoadingAction(false))
  }
}

function* alltask() {
  yield takeEvery<ActionType>('getDictData', getDictData)
}

// 导出当前模块的saga处理方法
export default function* sagas() {
  yield all([fork(alltask)])
}
